import React, { useState } from 'react';
import { Card, Form, Button, Alert } from 'react-bootstrap';
import api from '../services/api';
import Header from '../components/Header';

export default function Register({ setPage }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleRegister = async () => {
    try {
      const { data } = await api.post('/auth/register', { name, email, password });
      localStorage.setItem('token', data.token);
      setPage('dashboard');
    } catch (err) {
      setError(err.response?.data.error || 'Registration failed');
    }
  };

  return (
    <Card className="mx-auto card-transparent" style={{ maxWidth: '400px' }}>
      <Card.Body>
        <Header />
        <Form>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form.Group className="mb-3">
            <Form.Control type="text" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Control type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Control type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </Form.Group>
          <Button className="w-100 mb-2" onClick={handleRegister}>Register</Button>
          <div className="text-center">Already have an account? <Button variant="link" onClick={() => setPage('login')}>Login</Button></div>
        </Form>
      </Card.Body>
    </Card>
  );
}